function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuivant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14.339852,
    width: 21.9,
    viewBox: "0 0 21.9 14.339852",
    "data-name": "Layer 2",
    id: "Layer_2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-53.02,-56.580074)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 53.02,
    y1: 63.82,
    x2: 74.480003,
    y2: 63.82,
    id: "line6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "67.61 70.39 74.17 63.82 74.17 63.68 67.61 57.11",
    id: "polyline8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    style: {
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuivant);
export default __webpack_public_path__ + "static/media/suivant.1eec923a8cb249622698368592f2f682.svg";
export { ForwardRef as ReactComponent };